/**
 * @generated SignedSource<<6b484ac581edb20a31e384dcd3b101fa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type priorityField_updateWorkItemFieldsActionRenderer$data = {
  readonly fieldId: string;
  readonly priority: {
    readonly name: string | null;
  } | null;
  readonly " $fragmentType": "priorityField_updateWorkItemFieldsActionRenderer";
};
export type priorityField_updateWorkItemFieldsActionRenderer$key = {
  readonly " $data"?: priorityField_updateWorkItemFieldsActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"priorityField_updateWorkItemFieldsActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "priorityField_updateWorkItemFieldsActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "concreteType": "JiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "JiraPriorityField"
};

(node as any).hash = "8a19b32833d3f0442322814c42d5ad63";

export default node;
